import React from 'react';
import { MenuItem, Text } from '@zillow/constellation';

import type { NotificationItem } from '../NotificationCenter/interfaces/notificationItem';

import formatNotifications from '../NotificationCenter/util/formatNotifications';
import Constants from '../NotificationCenter/constants';

interface Props {
  key?: string;
  notificationItem: NotificationItem;
  onClick(): void;
}

const isValidNotificationType = (type: string) => {
  const response = Constants.NOTIFICATION_TYPES.hasOwnProperty(type);

  if (!response) {
    // eslint-disable-next-line no-console
    console.error('ERROR: found unregistered notification type', type);
  }

  return response;
};

const NotificationMenuItem = ({ key, notificationItem, onClick }: Props) => {
  const formatted = formatNotifications(notificationItem);
  const isRead = notificationItem.status.toUpperCase() === 'READ';

  if (!isValidNotificationType(notificationItem.type)) {
    return null;
  }

  return (
    <MenuItem onClick={onClick} key={key}>
      <div>
        <Text fontType="bodySmall" as={isRead ? '' : 'b'}>
          {formatted.notfificationText}
        </Text>
        <br />
        <Text fontType="finePrint" as={isRead ? '' : 'b'}>
          {formatted.timeStamp}
        </Text>
      </div>
    </MenuItem>
  );
};

export default NotificationMenuItem;
